import {
  DashboardOffer,
  DashboardHealth,
  DashboardProject,
  DashboardSocialBarDaily,
  DashboardSocialRadialBar,
  DashboardTransaction,
  DashboardNews,
  DashboardBalanceLine,
  DashboardDailyActive,
  DashboardLastData,
  DashboardOffers,
  DashboardOverallSales,
} from "../../components/DashboardComponents";
import "./Dashboard.css";

const Dashboard = () => {
  return (
    <div className="dashboard">
      <DashboardHealth />
      <div className="dashboard__projectTable">
        <DashboardProject />
      </div>
      <div className="flex-row dashboard__barNTransaction">
        <DashboardSocialBarDaily />
        <DashboardTransaction />
      </div>
      <div className="dashboard__offerNews flex-row">
        <DashboardOffer />
        <DashboardNews />
      </div>
      <DashboardBalanceLine />
      <div className="dashboard__skillsDataDaily flex-row">
        <DashboardDailyActive />
        <DashboardLastData />
      </div>
      <DashboardOffers />
      <div className="flex-row dashboard__barWatchedNRadial">
        <DashboardOverallSales />
        <DashboardSocialRadialBar />
      </div>
    </div>
  );
};

export default Dashboard;
